<template>
  <div class="dp02 p-3 mt-3">
    <div class="text-center w-100">
      <h2>{{ $t("CreateEditSubCategory.Header") }}</h2>
    </div>
    <v-multiselect
      ref="multiselect"
      v-model="subCategory"
      label="name"
      track-by="id"
      :options="availableSubCategories"
      @search-change="setValue"
      @input="
        setSubCategory(subCategory);
        deactivate();
        $emit('next-step');">
      <template slot="noResult">
        <div
          @click="
            setSubCategory({ id: null, name: subCategorySearch });
            deactivate();
            $emit('next-step');">
          {{ $t("common.Add") }}.. {{ subCategorySearch }}
        </div>
      </template>
    </v-multiselect>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'CreateEditTemplateSubCategory',
  data() {
    return {
      subCategory: '',
      subCategorySearch: ''
    };
  },
  computed: {
    availableSubCategories() {
      const options = this.getSubCategories().filter((x) => x.name !== 'None');
      options.unshift({ id: null, name: 'None' });
      return options;
    }
  },
  watch: {
    subCategory(val) {
      this.setSubCategory(val);
    }
  },
  mounted() {
    if (this.getCategory().id != null) {
      this.fetchSubCategories(this.getCategory().id);
    }
    this.subCategory = this.getSubCategory();
  },
  methods: {
    ...mapActions({ fetchSubCategories: 'createTemplate/fetchSubCategories' }),
    ...mapMutations({
      setSubCategory: 'createTemplate/setSubCategory'
    }),
    ...mapGetters({
      getSubCategories: 'createTemplate/getSubCategories',
      getCategory: 'createTemplate/getCategory',
      getSubCategory: 'createTemplate/getSubCategory'
    }),
    setValue(val) {
      this.subCategorySearch = val;
    },
    deactivate() {
      this.$refs.multiselect.deactivate();
    }
  }
};
</script>

<style lang="sass" scoped></style>
